export default "__VITE_ASSET__f6b0bf38__"